export default __webpack_public_path__ + "static/media/telcos_disabled.d8b5c5d9.svg";